import { UppKonvaShape } from '../upp-konva-shape';
import type { UppKonvaVertexShapeOptions } from '../upp-konva-options';

/** Perimeter vertex / polygon chain node. */
export class UppKonvaVertexShape extends UppKonvaShape {
    // 1. Type contract
    readonly kind = 'VERTEX' as const;

    // 2. Lifecycle
    constructor(opts: UppKonvaVertexShapeOptions) {
        const { sort, closed, poligon, ...rest } = opts;
        super({
            ...rest,
            data: { sort, closed, poligon },
        });
    }

    // 3. Perimeter fields (same contract as wire `data`; kept in `data` for serialization)

    get sort(): number {
        const v = this.data['sort'];
        return typeof v === 'number' && Number.isFinite(v) ? v : 0;
    }

    set sort(value: number) {
        this.data['sort'] = value;
    }

    get closed(): boolean {
        return this.data['closed'] === true;
    }

    set closed(value: boolean) {
        this.data['closed'] = value;
    }

    /**
     * Polygon chain id on the wire (`poligon`); legacy hydration may use `polygon` in `data` only until normalized.
     */
    get poligon(): string {
        const a = this.data['poligon'];
        const b = this.data['polygon'];
        const sa = typeof a === 'string' ? a.trim() : '';
        const sb = typeof b === 'string' ? b.trim() : '';
        return sa !== '' ? sa : sb;
    }

    set poligon(value: string) {
        this.data['poligon'] = value;
    }
}
